import script from "./ProjectBlockPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectBlockPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectBlockPage.vue?vue&type=style&index=0&id=042794e7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042794e7"]])

export default __exports__